export const ACCESS_LEVEL_TYPES = [
  'Supplier Reports',
  'Depot Delivery',
  'Depot Stock',
  'Distribution Centre Outbound',
  'Supplier Service',
  'Sales',
  'Online Sales',
  'Store Sales',
  'Wholesale Sales',
  'Store Stock',
  'Promotion Forecast',
  'Purchase Order',
  'Product Reference',
  'Sales Forecast',
  'Supplier Order Forecast',
  'Wastage And Markdown',
  'Availability',
  'Morrisons Documents (Supplier)',
  'Ranged Products',
  'Depot Rejections',
  'Manage Access',
  'Grant Access',
  'Modify Access',
  'Create User Roles',
  'Amend User Roles',
  'Add Company/Group',
  'Manage Company/Group Profile',
  'View Associated Groups',
  'Manage Communications',
  'Add New Message',
  'Amend/Delete Message',
  'Morrisons Documents (Admin)',
  'Supplier Admin',
  'Consolidator/Haulier Admin',
] as const

export const USER_TYPES = [
  { userType: 'Site Administrator', userRoleType: 'Morrisons' },
  { userType: 'Morrisons Internal', userRoleType: 'Morrisons' },
  { userType: 'Morrisons Manufacturing', userRoleType: 'Morrisons' },
  { userType: 'Supplier', userRoleType: 'Supplier' },
  { userType: 'Supplier Admin', userRoleType: 'Supplier' },
  { userType: 'Consolidator/Haulier', userRoleType: 'Consolidator/Haulier' },
  {
    userType: 'Consolidator/Haulier Admin',
    userRoleType: 'Consolidator/Haulier',
  },
] as const
